import axios from "axios";

const ApiMServer = axios.create({
  baseURL: process.env.REACT_APP_API_MOTOMCO  
});

export default ApiMServer;